const ByLegCollector = <R, I, A extends Array<any>>(
  Collector: (
    legIndex: number,
    ...args: A
  ) => { build: () => R; add: (item: I) => void },
  ...args: A
): {
  add: (legIndex: number, item: I) => void;
  build: () => Array<{ id: number } & R>;
} => {
  const byLeg: { build: () => R; add: (item: I) => void }[] = [];

  return {
    add(legIndex: number, item) {
      byLeg[legIndex] = byLeg[legIndex] || Collector(legIndex, ...args);
      byLeg[legIndex].add(item);
    },
    build() {
      return byLeg.map((collector, legIndex) => {
        return {
          id: legIndex,
          ...collector.build(),
        };
      });
    },
  };
};

export default ByLegCollector;
